import React from 'react'
import {useField} from "formik";
import styles from './DateTime.module.scss';
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import {HelpText} from "../HelpText/HelpText";

export const DateTime = ({ label, required, helpText, ...props }) => {
    const { t } = useTranslation();
    const [field, meta, helpers] = useField(props);

    return (
        <div>
            <div>
                {label &&
                    <label htmlFor={props.id || props.name} className={styles.datePickerLabel}>
                        {label}

                        {required && <span className={styles.required}>*</span>}
                    </label>
                }

                <DatePicker
                    {...field}
                    {...props}
                    id={props.id || props.name}
                    selected={(field.value && new Date(field.value)) || null}
                    onChange={helpers.setValue}
                    wrapperClassName="datePicker"
                    className={styles.datePickerContainer}
                />
            </div>

            {helpText &&
                <HelpText>{helpText}</HelpText>
            }

            {(meta.touched && meta.error) &&
                <div className={styles.error}>{t('input_component.is_required')}</div>
            }
        </div>
    );
};
